<template>
  <div class="introduce">
    <img src="@/views/recruit/yuanDesc/images/main_back.png" class="indexImg" />
    <div class="main_postInfo">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="单位招聘" name="A">
          <el-row :gutter="30" style="margin: 0 10px">
            <el-col
              v-for="(i, i_index) in list"
              :key="i_index"
              :lg="6"
              :md="8"
              :sm="12"
              :xs="12"
            >
              <el-card class="box-card" style="height: 250px">
                <div slot="header" class="clearfix" style="margin-bottom: 5px">
                  <a
                    style="float: left"
                    :href="'#/recruitInfo/index?deptCode=' + i.deptCode"
                    ><span>{{ i.postInfos[0].publishDept }}</span></a
                  >
                </div>
                <div style="height: 145px; width: 80%">
                  <div
                    v-for="(o, index) in i.postInfos"
                    :key="index"
                    class="text_item"
                  >
                    {{ index + 1 + "." + o.name }}
                  </div>
                </div>
                <div>
                  <a
                    class="button"
                    :href="'#/recruitInfo/index?deptCode=' + i.deptCode"
                    ><zr-icon icon="chevron-circle-right"></zr-icon>
                    <span class="hidden-md-and-down">更多</span></a
                  >
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="招聘信息" name="B"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getData } from "@/api/mainPage/mainPage";
import isMobile from "@/utils/device";
export default {
  name: "Index",
  data() {
    return {
      isMb: false, // 是否是移动设备
      list: {},
      mobileList: [],
      activeName: "A",
      path: "/recruitInfo/index",
    };
  },
  async created() {
    // 判断是否是移动设备
    this.isMb = await isMobile();
    await this.fetchInitData();
  },
  methods: {
    async fetchInitData() {
      let deptInformation = await getData();
      if (deptInformation.success) {
        this.list = deptInformation.data.postInfo;
        if (this.isMb) {
          for (let i = 0; i < this.list.length; i++) {
            this.mobileList = [];
            for (let j = 0; j < this.list[i].postInfos.length; j++) {
              if (j <= 1) {
                this.mobileList.push(this.list[i].postInfos[j]);
              }
            }
            this.list[i].postInfos = this.mobileList;
          }
        } else {
          for (let i = 0; i < this.list.length; i++) {
            this.mobileList = [];
            for (let j = 0; j < this.list[i].postInfos.length; j++) {
              if (j <= 4) {
                this.mobileList.push(this.list[i].postInfos[j]);
              }
            }
            this.list[i].postInfos = this.mobileList;
          }
        }
      } else {
        this.$message.error(deptInformation.message);
      }
    },
    handleClick(tab) {
      this.activeName = tab.name;
      if (this.activeName == "B") {
        this.$router.push({ path: this.path });
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "public/static/scss/commTableLayouts";
.link_li {
  margin-top: 15px;
  height: 30px;
}

.button {
  padding: 0;
  float: right;
}

span.primary_text {
  color: #1890ff;
}
span.more_text {
  color: #13ce66;
}

.main_postInfo {
  margin-top: 10px;
}

text_item {
  white-space: pre-wrap;
  display: block;
  word-wrap: break-word;
  overflow: hidden;
}

.clearfix {
  text-align: center;
  height: 20px;
}

.indexImg {
  width: 100%;
}
</style>
